import React, { PropsWithChildren } from 'react';
import { Image, StyleSheet, View } from 'react-native';

import { MODAL_BORDER_RADIUS } from '@/navigation/screen-presets';

/**
 * Full-screen background for entry confirmation flows
 */
export const EntryConfirmationBackground = ({ children }: PropsWithChildren<{}>) => (
    <View style={styles.root}>
        <Image
            source={require('@/assets/images/entry_confirmation_background.png')}
            style={[StyleSheet.absoluteFill, styles.image]}
            resizeMode="cover"
        />
        {children}
    </View>
);

const styles = StyleSheet.create({
    root: {
        flex: 1,
        borderTopLeftRadius: MODAL_BORDER_RADIUS,
        borderTopRightRadius: MODAL_BORDER_RADIUS,
        overflow: 'hidden',
    },
    image: {
        width: '100%',
        height: '100%',
    },
});
